module.exports = __webpack_public_path__ + "static/img/cjzh-partners.95eddcde.png";